/* eslint-disable no-loop-func */
import { TermLessonType } from 'types/course.type';
import { faNumber } from './common.util';
import fa from 'locales/fa.json';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const calculateWeeks = (data, days, hourPerWeek) => {
  const allWeeks = []; // final data that keep weeks and lesson of each day in week

  if (data && !!days?.length) {
    const lessons: any[] = [...data]; // all lessons
    const dailySecond = Number(((hourPerWeek * 3600) / (days.length || 1)).toFixed(0)); // time of each day in second
    let previousWeekProgress = 100;

    while (lessons.length > 0) {
      const week = [];
      days
        .sort((a, b) => a - b)
        .forEach((day, index) => {
          const dayLessons = [];
          let dayTime = 0;
          const endTime =
            index === days.length - 1
              ? hourPerWeek * 3600 - week.reduce((a, b) => a + b.total, 0)
              : dailySecond;

          while (dayTime < endTime && !!lessons.length) {
            const item = lessons.shift();
            dayLessons.push({ ...item, open: previousWeekProgress === 100 });
            dayTime += item.time;
          }

          week.push({
            total: dayTime,
            title: day,
            data: dayLessons,
          });
        });

      const passed = week.map((item) => item.data.map((key) => key.passed)).flat();
      const progress = Math.round((passed.filter((k) => k).length * 100) / passed.length);
      const total = week.reduce((a, b) => a + b.total, 0);
      const order = allWeeks.length + 1;
      allWeeks.push({ total, data: week, progress, previousWeekProgress, order });
      previousWeekProgress = progress;
    }
  }

  return allWeeks;
};

export const mapTermData = (data): TermLessonType[] => {
  return data.items
    ?.map((item) => {
      return {
        ...item,
        passed: data.passed_lessons?.includes(item.lesson_id),
        lessonIndex:
          data.items
            .filter((key) => key.workshop_id === item.workshop_id)
            .findIndex((key) => key.lesson_id === item.lesson_id) + 1,
      };
    })
    .sort((a, b) => a.order - b.order);
};

export const getCallSection = (biggestCallSection, list): number =>
  [...Array(biggestCallSection).keys()]
    .map((i) => i + 1)
    .reverse()
    .map((num) => {
      const items = list?.filter((k) => k.call_section === num);
      return !!items?.length && items?.every((k) => !!k.passed) ? num : 0;
    })
    .reduce((a, b) => (b > a ? b : a));

export const calcWeekTime = (groupData, selectedOptions): string => {
  const fixes = groupData?.workshops.filter((item) => item.type === 'isFixed');
  const optional = groupData?.workshops.filter((item) => item.type === 'isOptional');
  const selective = groupData?.selectiveWorkshops.map((item) =>
    item.workshops.find((k) => selectedOptions.includes(k.id)),
  );

  const fixesTime = fixes?.reduce((a, b) => a + Number(b.time), 0);
  const selectiveTime = selective?.reduce((a, b) => a + Number(b?.time), 0);
  const optionalTime = optional
    ?.filter((item) => (selectedOptions.includes(item.id) ? item : null))
    .reduce((a, b) => a + Number(b.time), 0);

  const weekTime = (optionalTime + fixesTime + selectiveTime) / (60 * groupData?.weeks);
  return `${faNumber(Math.floor(weekTime / 60))} ${fa.global.hour} و ${faNumber(
    Math.floor(weekTime % 60),
  )} ${fa.global.minute}`;
};
